





































import StartPageSlider from '../../parts/slider/StartPageSlider.vue';
import AppPicture from '@/uikit/components/AppPicture/AppPicture.vue';
import AppSvgIcon from '@/uikit/components/AppSvgIcon/AppSvgIcon.vue';
import {
  LayoutConfig,
  LayoutDataSet,
} from '@/uikit/components/AppDefaultLayout/types/LayoutTypes';
import { MONTHS2 } from '@/pages/activities/const';
import AppButtonNew from "@/uikit/components/AppButtonNew/AppButtonNew.vue";
import { ButtonType } from "@/uikit/components/AppButtonNew/defaultConfigs";

export default {
  components: {
    AppButtonNew,
    AppSvgIcon,
    AppPicture,
    StartPageSlider,
  },
  props: {
    cfg: {
      type: Object as () => LayoutConfig['content']['startPage']['sections']['news'],
      required: true,
    },
    data: {
      type: Array as () => LayoutDataSet['news'],
    },
  },
  computed: {
    getButtonType() {
      return ButtonType;
    },
  },
  methods: {
    getDay(val: string) {
      return new Date(val).getDate();
    },
    getEventType(item: any) {
      const ret = this.$store.state.blogEventsDict.find((sprElem: any) => {
        return sprElem.id === item.event_type;
      });
      if (ret) {
        return ret.name;
      }
      return '';
    },
    getMonth(val: string) {
      return MONTHS2[String(new Date(val).getMonth() + 1)];
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/news/News.vue